import { g17ecoApi, transformResponse } from '@api/g17ecoApi';

export interface UsedScopes {
  standards: Record<string, string[]>;
  frameworks: Record<string, string[]>;
}

export const organizationApi = g17ecoApi
  .enhanceEndpoints({
    addTagTypes: ['organization-used-scopes'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOrganizationUsedScopes: builder.query<UsedScopes, string>({
        transformResponse,
        query: (initiativeId) => ({
          url: `/organizations/${initiativeId}/scopes/used`,
          method: 'get',
        }),
        providesTags: ['organization-used-scopes'],
      }),
    }),
  });

export const { endpoints, useGetOrganizationUsedScopesQuery } = organizationApi;
